import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
import 'rxjs/add/operator/switchMap';
declare var $;

@Injectable()
export class CreditosHipotecariosService {

  private service_url;
  private service_operations_url : string = '';
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/creditos/hipotecario';
    this.service_operations_url = this.constantsService.apiURL + '/calculo/insoluto';
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'promedio_mensual': '',
      'buro_mensual': '',
      'capacidad_pago': ''
    };
  }

  getCapacidadPago(tasa : number, capacidad_pago : number, plazo_periodo : number, plazo_medida : string, periodicidad: number) {
    let serviceUrl = this.service_operations_url + '/creditoMaximo?tasa=' + tasa + '&capacidad_pago='+ capacidad_pago +'&plazo_periodo=' + plazo_periodo +'&plazo_medida=' + plazo_medida +'&periodicidad=' + periodicidad;
    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  /*
  Save a new Credito
  */
 public save(credito: any) {
    return this.http.post(this.service_url + '/simulacion', credito, this.authService.getAuthHeaders());
  }

  /*
  Update a Credito
  */
 public update(credito: any) {
    return this.http.put(this.service_url + '/simulacion', credito, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(filter, search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&filter=" + filter + "&search=" + search, this.authService.getAuthHeaders());
  }
  
  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }

  getCreditoHipotecario(idCreditos : number){
    return this.http.get(this.service_url + '?idCreditos='+ idCreditos  , this.authService.getAuthHeaders());
  }

  /**
   * Revisa si las secciones del crédito estan completas
   */
  validateSections(idCreditos : number){
    return this.http.get(this.service_url + '/validateSections/'+ idCreditos  , this.authService.getAuthHeaders());
  }

  /*
  Validators
  */
  public validateCapacidad(data){
    let error = [];
    
    if(!this.validatorService.required(data.promedio_mensual)){
      error["ingreso"] = this.errorService.required;
    }
    if(!this.validatorService.required(data.buro_mensual)){
      error["buro"] = this.errorService.required;
    }
    return error;
  }

  public validateCalcularCapacidad(data : any, prestamo : any){
    let error = [];
    
    if(!this.validatorService.required(data.promedio_mensual)){
      error["ingreso"] = this.errorService.required;
    }
    if(!this.validatorService.required(data.buro_mensual)){
      error["buro"] = this.errorService.required;
    }
    if(!this.validatorService.required(data.capacidad_pago)){
      error["capacidad"] = this.errorService.required;
    }
    if(!this.validatorService.required(prestamo.tasa)){
      error["tasa"] = this.errorService.required;
    }
    if(!this.validatorService.required(prestamo.plazo_periodo)){
      error["plazo"] = this.errorService.required;
    }

    return error;
  }

  public validate(data){
    let error = [];
    
    if(!this.validatorService.required(data.promedio_mensual)){
      error["ingreso"] = this.errorService.required;
    }
    if(!this.validatorService.required(data.buro_mensual)){
      error["buro"] = this.errorService.required;
    }
    if(!this.validatorService.required(data.capacidad_pago)){
      error["capacidad"] = this.errorService.required;
    }

    return error;
  }

  public validateClient(data:any){
    let error = [];
    
    if(!this.validatorService.required(data.nombre)){
      error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.email)){
      error["email"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data.email, 40)){
      error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data.email)) {
      error['email'] = this.errorService.email;
    }
    
    return error;
  }

  public validateCreditoSeleccionado(creditoSeleccionado:number, creditoMaximo:number){
    let error = [];

    if(creditoSeleccionado == 0){
      error['customMaxLoan'] = "El crédito debe ser mayor a cero";
    }
    else if(creditoSeleccionado > creditoMaximo){
      error['customMaxLoan'] = "El crédito debe ser menor al crédito máximo";
    }
    
    return error;
  }

  

}



// WEBPACK FOOTER //
// ./src/app/services/creditos-hipotecarios.service.ts